import { type FC } from 'react';

import { Checklist } from '@eneco/components/ui/Checklist/Checklist';
import { Fields } from '@sitecore/types/OfferStep';

import { Ribbon } from '../../../shared/components/Ribbon/Ribbon';
import { checkIfOfferHasTimeOfUseProduct } from '../../../shared/helpers/misc';
import { Offer } from '../../../shared/types';

interface TOURibbonProps {
  textualData?: Fields;
  offer: Offer;
}

export const TOURibbon: FC<TOURibbonProps> = ({ textualData, offer }) => {
  if (!checkIfOfferHasTimeOfUseProduct(offer)) return null;

  return (
    <Ribbon
      size="small"
      emphasis="high"
      ribbonTitle={textualData?.promotionTexts?.timeOfUseRibbonContent?.value}
      title={textualData?.content?.timeOfUseInfoDialog?.value?.title || ''}
      text={textualData?.content?.timeOfUseInfoDialog?.value?.content}
      trigger={textualData?.content?.timeOfUseInfoDialog?.value?.triggerText}
      contentContainer="dialog"
      hasInfoIcon={false}
      hasGiftIcon={false}>
      <Checklist>
        {textualData?.content?.timeOfUseInfoDialogUspList?.value?.enum?.map(({ label, name }) => (
          <Checklist.Item alignY="start" key={name} gap={2}>
            {label}
          </Checklist.Item>
        ))}
      </Checklist>
    </Ribbon>
  );
};
